import { render, staticRenderFns } from "./support.vue?vue&type=template&id=564cafd1"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564cafd1')) {
      api.createRecord('564cafd1', component.options)
    } else {
      api.reload('564cafd1', component.options)
    }
    module.hot.accept("./support.vue?vue&type=template&id=564cafd1", function () {
      api.rerender('564cafd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/partner/view/support.vue"
export default component.exports